// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Session warning / expired — aligned with INCYIA modal shell */

.sa-overlay {
  position: fixed;
  inset: 0;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(11, 30, 45, 0.45);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  animation: sa-fade-in 0.18s ease;
}

.sa-card {
  width: min(420px, 100%);
  background: #fff;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 30px 80px -24px rgba(0, 0, 0, 0.45);
  font-family: Lato, sans-serif;
}

.sa-card--enter {
  animation: sa-slide-up 0.28s cubic-bezier(0.22, 1, 0.36, 1);
}

.sa-eyebrow {
  margin: 0 0 4px;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #b86e00;
}

.sa-card .incyia-modal-head h3 {
  font-size: 17px;
}

.sa-meter {
  width: 100%;
  height: 6px;
  border-radius: 99px;
  background: #dee4f0;
  overflow: hidden;
  margin-top: 4px;
}

.sa-meter-fill {
  height: 100%;
  width: 100%;
  transform-origin: left center;
  border-radius: 99px;
  background: linear-gradient(90deg, #0d9b87, #4fe0c2);
  transition: transform 1s linear;
}

.sa-full-btn {
  width: 100% !important;
  justify-content: center;
}

@keyframes sa-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes sa-slide-up {
  from {
    opacity: 0;
    transform: translateY(16px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/sessionAlerts.css"],"names":[],"mappings":"AAAA,gEAAgE;;AAEhE;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,iDAAiD;EACjD,6BAA6B;AAC/B;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;EACnB,oDAAoD;EACpD,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":["/* Session warning / expired — aligned with INCYIA modal shell */\n\n.sa-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 99999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  background: rgba(11, 30, 45, 0.45);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n  animation: sa-fade-in 0.18s ease;\n}\n\n.sa-card {\n  width: min(420px, 100%);\n  background: #fff;\n  border-radius: 14px;\n  overflow: hidden;\n  box-shadow: 0 30px 80px -24px rgba(0, 0, 0, 0.45);\n  font-family: Lato, sans-serif;\n}\n\n.sa-card--enter {\n  animation: sa-slide-up 0.28s cubic-bezier(0.22, 1, 0.36, 1);\n}\n\n.sa-eyebrow {\n  margin: 0 0 4px;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #b86e00;\n}\n\n.sa-card .incyia-modal-head h3 {\n  font-size: 17px;\n}\n\n.sa-meter {\n  width: 100%;\n  height: 6px;\n  border-radius: 99px;\n  background: #dee4f0;\n  overflow: hidden;\n  margin-top: 4px;\n}\n\n.sa-meter-fill {\n  height: 100%;\n  width: 100%;\n  transform-origin: left center;\n  border-radius: 99px;\n  background: linear-gradient(90deg, #0d9b87, #4fe0c2);\n  transition: transform 1s linear;\n}\n\n.sa-full-btn {\n  width: 100% !important;\n  justify-content: center;\n}\n\n@keyframes sa-fade-in {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes sa-slide-up {\n  from {\n    opacity: 0;\n    transform: translateY(16px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
